import { Input, Modal, Space } from 'antd';

import Form from '../Form';
import { JobPostingActionModal } from './RequestJobPostingActionsModal';

const CancelRequestJobPostingModal: React.FC<JobPostingActionModal> = ({
  requestJobPosting,
  form,
  ...props
}) => {
  return (
    <Modal {...props}>
      <Space direction="vertical">
        <span>
          Ao cancelar a requisição, o fluxo será suspenso e não será possível reiniciá-lo. Tem
          certeza que deseja cancelar a requisição <strong>{requestJobPosting.name}</strong>?
        </span>
        <Form form={form}>
          <Form.Item name="comment">
            <Input.TextArea
              placeholder="Digite o motivo do cancelamento da requisição de vaga"
              defaultValue=""
            />
          </Form.Item>
        </Form>
      </Space>
    </Modal>
  );
};

export default CancelRequestJobPostingModal;
